import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import u from "./iconfont.es5471.js";
const d = {
  display: "block"
}, v = ({ size: e = 16, useVw: n, useRem: l, color: c, withColor: i, removeClassName: t, disableSSR: h, style: o, ...m }) => {
  const p = o ? { ...d, ...o } : d;
  return /* @__PURE__ */ a.createElement(u, { disableSSR: h }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-tuijianguanjihua", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-æ¨èå®è®¡å"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: i ? r(c, 0, "#262933") : "#262933",
        datafollowfill: i ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M12.706 10.183A3.279 3.279 0 0 1 15.989 6.9a3.286 3.286 0 0 1 3.283 3.28 3.25 3.25 0 0 1-3.185 3.287h-.183l-.035-.001a3.277 3.277 0 0 1-3.163-3.283ZM15.989 8.7c-.823 0-1.483.66-1.483 1.483 0 .803.62 1.446 1.416 1.484h.15a1.452 1.452 0 0 0 1.4-1.475v-.009c0-.813-.663-1.483-1.483-1.483ZM10.4 18.113a3.72 3.72 0 0 1 3.72-3.72h3.76a3.72 3.72 0 0 1 3.72 3.72v.94a1.84 1.84 0 0 1-1.84 1.84h-7.52a1.84 1.84 0 0 1-1.84-1.84v-.94Zm3.72-1.92c-1.06 0-1.92.86-1.92 1.92v.94c0 .022.019.04.04.04h7.52a.04.04 0 0 0 .04-.04v-.94a1.92 1.92 0 0 0-1.92-1.92h-3.76Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M9 3.1A4.9 4.9 0 0 0 4.1 8v13A3.9 3.9 0 0 0 8 24.9h1.072a3.1 3.1 0 0 1 1.963.7l3.129 2.56a2.9 2.9 0 0 0 3.673 0l3.128-2.56a3.1 3.1 0 0 1 1.963-.7H24a3.9 3.9 0 0 0 3.9-3.9V8A4.9 4.9 0 0 0 23 3.1H9ZM5.9 8A3.1 3.1 0 0 1 9 4.9h14A3.1 3.1 0 0 1 26.1 8v13a2.1 2.1 0 0 1-2.1 2.1h-1.072a4.9 4.9 0 0 0-3.103 1.108l-3.128 2.56a1.1 1.1 0 0 1-1.393 0l-3.129-2.56A4.9 4.9 0 0 0 9.072 23.1H8A2.1 2.1 0 0 1 5.9 21V8Z"
        }
      )
    )
  )));
}, A = v;
export {
  A as default
};
